import {Component, Input} from '@angular/core';

type Size = 'small' | 'medium' | 'large';

@Component({
  selector: 'mc-alert-link',
  templateUrl: './alert-link.component.html',
  styleUrls: ['./alert-link.component.scss'],
})
export class AlertLinkComponent {
  @Input() href: string = '';
  @Input() size: Size = 'large';
}
